import { useQuery } from "@tanstack/react-query";

import { getGrantAffinityProfile, isGrantAffinityProfile } from "@/api/grant_affinity_profile";

type UseGrantDiscoverAffinityProfileOptions = {
  municipalityId?: number;
  canUseGrantDiscover: boolean;
};

export function useGrantDiscoverAffinityProfile({
  municipalityId,
  canUseGrantDiscover,
}: UseGrantDiscoverAffinityProfileOptions) {
  const { data: profileResponse, isLoading: profileLoading } = useQuery({
    queryKey: ["grant_affinity_profile", municipalityId],
    queryFn: () => getGrantAffinityProfile(municipalityId!),
    enabled: canUseGrantDiscover && Boolean(municipalityId),
    refetchInterval: (query) => {
      const data = query.state.data;
      if (data && isGrantAffinityProfile(data) && data.complete && !data.embedded) {
        return 3000;
      }
      return false;
    },
  });

  const affinityProfile =
    profileResponse && isGrantAffinityProfile(profileResponse) ? profileResponse : null;
  const profileComplete = affinityProfile?.complete === true && affinityProfile?.embedded === true;
  const profileAwaitingEmbed =
    affinityProfile?.complete === true && affinityProfile?.embedded === false;

  return {
    affinityProfile,
    profileComplete,
    profileAwaitingEmbed,
    profileLoading,
  };
}
